import script from "./packages.vue?vue&type=script&lang=ts&setup=true"
export * from "./packages.vue?vue&type=script&lang=ts&setup=true"

import "./packages.vue?vue&type=style&index=0&id=7a6bb0f3&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a6bb0f3"]])

export default __exports__